import { render, staticRenderFns } from "./modalDetalleAnulado.vue?vue&type=template&id=35f9fbe4"
import script from "./modalDetalleAnulado.vue?vue&type=script&lang=js"
export * from "./modalDetalleAnulado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports